var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('homePage'),_c('homePage1'),_c('homePage2'),_c('homePage3'),_c('homePage4'),_c('homePage5'),_c('homePage6'),_c('footerBox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }